import React, {Component} from 'react';
import {gpn} from "../../GPN"
import axios from "axios";
import config from "../../config";
import {toast} from "react-toastify";
import Modal from "../sections/MUI/Modal";

class Order extends Component {

    state = {
        user: {
            fullName: "",
            phoneNumber: ""
        },
        fullName: "",
        phoneNumber: "",
        tel: "",
        address: "",
        postalCode: "",
        status: "",
        created_at: "",
        amount: "",
        cart: [],
        paymentMethod: "",
        otherData: null,

        editStatus: "",


        invoice: "",
        mobileNumber: "",
        payerMail: "",
        payerName: "",
        nationalCode: "",
        url: "",
        urlId: "",
        referenceNumber: "",
        trackId: "",
        maskedCardNumber: "",
        hashedCardNumber: "",
        requestDate: "",

        transactionId: "",

        token: "",

        firstName: "",
        lastName: "",
        mobile: "",
        description: "",

        modalDaapApp: null
    };

    componentDidMount() {
        this.getOrderData(this.props.params.id);
    }

    getOrderData(id) {
        axios.get(`${config.api}/payment/order?token=${config.token}&id=${id}`)
            .then(r => {
                const {
                    user,
                    fullName,
                    phoneNumber,
                    tel,
                    address,
                    postalCode,
                    status,
                    created_at,
                    amount,
                    cart,
                    paymentMethod,
                    otherData,

                    invoice,
                    mobileNumber,
                    payerMail,
                    payerName,
                    nationalCode,
                    url,
                    urlId,
                    referenceNumber,
                    trackId,
                    maskedCardNumber,
                    hashedCardNumber,
                    requestDate,
                    transactionId,
                    token,

                    firstName,
                    lastName,
                    mobile,
                    description
                } = r.data.order

                this.setState({
                    user,
                    fullName,
                    phoneNumber,
                    tel,
                    address,
                    postalCode,
                    status,
                    created_at,
                    amount,
                    cart,
                    paymentMethod,
                    otherData,
                    token,

                    invoice,
                    mobileNumber,
                    payerMail,
                    payerName,
                    nationalCode,
                    url,
                    urlId,
                    referenceNumber,
                    trackId,
                    maskedCardNumber,
                    hashedCardNumber,
                    requestDate,
                    transactionId,

                    firstName,
                    lastName,
                    mobile,
                    description
                });
            })
            .catch(err => {
                console.error(err);
            });
    }

    handleSubmitStatus(status) {
        const id = this.props.params.id;
        let params = new URLSearchParams();
        params.append('id', id);
        params.append('status', status);
        axios.put(`${config.api}/payment/order/status?token=${config.token}`, params)
            .then(r => {
            })
            .catch(err => {
            });
    }

    delete() {
        toast.error("در حال حذف ...")
        const id = this.props.params.id;
        axios.delete(`${config.api}/payment/order?token=${config.token}&id=${id}`)
            .then(r => {
                toast.error("با موفقیت حذف شد.");
                setTimeout(() => {
                    this.props.navigate(-1);
                }, 1500);
            })
            .catch(err => {
                toast.error("خطا!")
            });
    }

    renderStatus(paymentMethod, status) {
        switch (paymentMethod) {
            case "نقد":
                return (
                    <div className="form-control">
                        <select name="status" id="status"
                                defaultValue={status}
                                onChange={(e) => {
                                    const {value} = e.target;
                                    this.setState({
                                        status: value
                                    });
                                    this.handleSubmitStatus(value);
                                }}>
                            <option value="پرداخت نشده"
                                    selected={status === "پرداخت نشده"}>پرداخت نشده
                            </option>
                            <option value="پرداخت موفق - در دست بررسی"
                                    selected={status === "پرداخت موفق - در دست بررسی"}>پرداخت موفق - در دست بررسی
                            </option>
                            <option value="پرداخت موفق - ارسال شده"
                                    selected={status === "پرداخت موفق - ارسال شده"}>پرداخت
                                موفق - ارسال شده
                            </option>
                        </select>
                    </div>
                );
            case "چک":
                return (
                    <div className="form-control">
                        <select name="status" id="status"
                                defaultValue={status}
                                onChange={(e) => {
                                    const {value} = e.target;
                                    this.setState({
                                        status: value
                                    });
                                    this.handleSubmitStatus(value);
                                }}>
                            <option value="پرداخت نشده - پرداخت چکی"
                                    selected={status === "پرداخت نشده - پرداخت چکی"}>پرداخت نشده - پرداخت چکی
                            </option>
                            <option value="پرداخت موفق - در دست بررسی"
                                    selected={status === "پرداخت موفق - در دست بررسی"}>پرداخت موفق - در دست بررسی
                            </option>
                            <option value="پرداخت موفق - ارسال شده"
                                    selected={status === "پرداخت موفق - ارسال شده"}>پرداخت
                                موفق - ارسال شده
                            </option>
                        </select>
                    </div>
                );
            default:
                return (<div className="status">{status}</div>);
        }
    }

    verifyDaapApp() {
        let {transactionId} = this.state;
        toast.info("در حال دریافت وضعیت سفارش ...");
        axios.get(`${config.api}/payment/order/daapapp?token=${config.token}&transactionId=${transactionId}`)
            .then(r => {
                let {message, data} = r.data;
                this.setState({
                    modalDaapApp: {
                        message,
                        data
                    }
                });
            })
            .catch(err => {
                toast.error("خطایی رخ داده است!");
            });
    }

    render() {
        const {
            user,
            fullName,
            phoneNumber,
            tel,
            address,
            postalCode,
            status,
            created_at,
            amount,
            cart,
            paymentMethod,
            otherData,

            invoice,
            mobileNumber,
            payerMail,
            payerName,
            nationalCode,
            referenceNumber,
            trackId,
            maskedCardNumber,
            hashedCardNumber,
            requestDate,

            url,
            transactionId,
            token,

            firstName,
            lastName,
            mobile,
            description,

            modalDaapApp
        } = this.state;

        let jsonDaapApp = "";
        if (modalDaapApp) {
            jsonDaapApp = JSON.stringify(modalDaapApp.data, null, 2);
        }
        return (
            <div className="order-data">
                {modalDaapApp ?
                    <Modal display={modalDaapApp} title="وضعیت سفارش داپ اپ"
                           onCloseClick={() => this.setState({modalDaapApp: null})}>
                        <div style={{textAlign: "center"}}>
                            {modalDaapApp.message}
                        </div>
                        <br/>
                        <div style={{direction: "ltr", textAlign: "center"}}>{jsonDaapApp}</div>
                    </Modal>
                    : null}
                <div className="user">
                    <h1>اطلاعات کاربر</h1>
                    <div className="row">
                        <div className="col-md-6">
                            <span>نام و نام خانوادگی:</span><span>{user.fullName}</span>
                        </div>
                        <div className="col-md-6">
                            <span>شماره موبایل:</span><span>{user.phoneNumber}</span>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <div className="body">
                    <h1>سفارش</h1>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="payment-method"
                                 style={{
                                     backgroundColor: paymentMethod === "نقد" ? "#0e5480" :
                                         paymentMethod === "چک" ? "#b9174e" : paymentMethod === "وام" ? "#49288d" : "#97342b"
                                 }}>{paymentMethod}</div>
                        </div>
                        <div className="col-md-6">
                            {this.renderStatus(paymentMethod, status)}
                        </div>
                        <div className="col-md-6">
                            <div className="full-name">{fullName}</div>
                        </div>
                        <div className="col-md-6">
                            <div className="phone-number">{phoneNumber}</div>
                        </div>
                        <div className="col-md-6">
                            <div className="tel">{tel}</div>
                        </div>
                        <div className="col-md-6">
                            <div className="address">{address}</div>
                        </div>
                        <div className="col-md-6">
                            <div className="postal-code">{postalCode}</div>
                        </div>
                        <div className="col-12">
                            <div className="cart-data">
                                {
                                    cart?.map((c, i) =>
                                        <div key={"c" + i} className="cart-data-item">
                                            <div className="row">
                                                <div className="col-auto">
                                                    <img
                                                        src={c.images ? c.images.length > 0 ? c.images[0] : "" : ""}
                                                        alt=""/>
                                                </div>
                                                <div className="col">
                                                    <div className="title">{c.title + " (" + c.count + ")"}</div>
                                                    <div className="price">{config.priceFormatter(c.price)}</div>
                                                </div>
                                                <div className="col-auto">
                                                    <span className="material"
                                                          onClick={() => window.open(`${config.appURL}/product/${c.slug}`, "_blank")}>arrow_back</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        {
                            paymentMethod === "چک" ?
                                <div className="col-12">
                                    <div className="chek">
                                        <div className="row justify-content-center">
                                            <div className="col-6">
                                                <span>جمع کل اقساط:&nbsp;</span><span>{config.priceFormatter(otherData?.percentOfMonths)}</span>
                                            </div>
                                            <div className="col-6">
                                                <span>مبلغ هر قسط:&nbsp;</span><span>{config.priceFormatter(otherData?.pricePerGhest)}</span>
                                            </div>
                                            <div className="col-12">
                                                <div className="sum">
                                                    <span>جمع کل:</span><span>{config.priceFormatter(amount)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null
                        }

                        {paymentMethod === "قسطا" ?
                            <div className="ghesta-payment">
                                <div className="row">
                                    <div className="col-md-6">
                                        <p><span>فاکتور:</span><span>{invoice}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>شماره موبایل:</span><span>{mobileNumber}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>ایمیل پرداخت کننده:</span><span>{payerMail}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>نام پرداخت کننده:</span><span>{payerName}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>کد ملی:</span><span>{nationalCode}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>شماره مرجع:</span><span>{referenceNumber}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>شماره رهگیری:</span><span>{trackId}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>شماره کارت:</span><span>{maskedCardNumber}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>شماره کارت هش شده:</span><span>{hashedCardNumber}</span></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><span>تاریخ درخواست:</span><span>{requestDate}</span></p>
                                    </div>
                                </div>
                            </div> :
                            paymentMethod === "داپ اپ" ?
                                <div className="daapapp-payment">
                                    <p><span>شناسه:</span><span>{transactionId}</span></p>
                                    <p><span>لینک:</span><span>{url}</span></p>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <br/>
                                            <div className="form-control">
                                                <button type="button" onClick={() => this.verifyDaapApp()}>بررسی وضعیت
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div> :
                                paymentMethod === "GSMPay" ?
                                    <div className="gsmpay-payment">
                                        <div className="row justify-content-center">
                                            <div className="col-md-6">
                                                <p><span>نام:</span><span>{firstName}</span></p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><span>نام خانوادگی:</span><span>{lastName}</span></p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><span>موبایل:</span><span>{mobile}</span></p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><span>توضیحات:</span><span>{description}</span></p>
                                            </div>
                                            <div className="col-12">
                                                <p><span>شماره فاکتور:</span><span>{invoice}</span></p>
                                            </div>
                                            <div className="col-12">
                                                <p><span>توکن:</span><span>{token}</span></p>
                                            </div>
                                            <div className="col-12">
                                                <p><span>لینک:</span><span>{url}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                        }
                        <div className="col-12">{created_at}</div>
                    </div>
                </div>
                <br/><br/>
                <div className="opt">
                    <div className="row">
                        <div className="col-auto">
                            <button type="button" style={{backgroundColor: "#9c1116"}}
                                    onDoubleClick={this.delete.bind(this)}>حذف کردن سفارش
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(Order);